export const CLEAN_REDUCER = 'CLEAN_REDUCER';
